import type { ChangeSignal } from '@thom/folio-domain/core/ports/live'
import { filterFor } from '@thom/pb/filter-builder'
import { DOCS, THREADS } from './feedback-adapter'
import { projectClauses } from './project-clauses'
import type { Realtime } from './realtime'

type FeedbackSignals = {
	readonly threads: ChangeSignal<string>
	readonly docs: ChangeSignal<string>
}

type ProjectColumns = {
	'project.slug': string
	'project.domain.slug': string
	'project.domain.client.slug': string
}

const byProject = (ref: string) => filterFor<ProjectColumns>()([...projectClauses(ref)])

const signal = ({ client, connection }: Realtime, collection: string): ChangeSignal<string> => ({
	source: { client, collection, map: record => record, connection },
	options: project => ({ filter: byProject(project), sort: '-updated', perPage: 1 }),
})

const createFeedbackSignals = (realtime: Realtime): FeedbackSignals => ({
	threads: signal(realtime, THREADS),
	docs: signal(realtime, DOCS),
})

export { createFeedbackSignals }
export type { FeedbackSignals }
